/**************************************************
 * Nombre:       BarraCell
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {ButtonBase, Drawer, Grid, IconButton, InputAdornment, TextField, Typography} from "@mui/material";
import logo from '../../Recursos/logo_color.svg'
import logoBlanco from '../../Recursos/logo_blanco.svg'
import {Close, Menu, Search, WhatsApp} from '@mui/icons-material'
import {useState} from "react";
import {SECCIONES} from "../../Constantes";
import {useNavigate} from "react-router";
import {theme} from "../../Tema";
import {useIrRuta} from "../../Utilidades/useIrRuta";
import {iniciarChatWass} from "../../Utilidades/iniciarChatWass";

const BarraCell = ({negro}) => {
    const navigate = useNavigate()
    const {ir} = useIrRuta()
    const [open, setOpen] = useState(false)
    const [palabra, setPalabra] = useState('')


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: '#EDFCF6', px: 3, py: 3}}
        >

            <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                <img
                    onClick={() => navigate('/Home')}
                    src={logo} width={100} height={'auto'} style={{marginTop: -5}}/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-end'}
                alignItems={'flex-start'}
                size={6}
                spacing={1}
            >

                <IconButton
                    onClick={() => iniciarChatWass({mensaje: 'Hola Pet Supplies'})}
                    sx={{backgroundColor: theme.palette.primary.main, mt: -1.5}}
                >
                    <WhatsApp sx={{fill: '#fff'}}/>
                </IconButton>

                <IconButton
                    onClick={() => setOpen(true)}
                    sx={{backgroundColor: theme.palette.primary.main, mt: -1.5}}
                >
                    <Menu sx={{fill: '#fff'}}/>
                </IconButton>

            </Grid>


            <Drawer open={open} onClose={() => setOpen(false)}
                    anchor={'right'}
            >

                <Grid container size={{xs: 12, ms: 12, md: 12}}>
                    <IconButton
                        onClick={() => setOpen(false)}
                    >
                        <Close sx={{fill: '#fff'}}/>
                    </IconButton>
                </Grid>

                <Grid container size={{xs: 12, ms: 12, md: 12}}
                      sx={{width: 300, p: 2, marginTop: 2, justifyContent: 'center'}}>


                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'center', marginTop: 2}}>
                        <ButtonBase
                            onClick={() => {
                                setOpen(false)
                                setTimeout(() => {
                                    navigate('/Home')
                                }, 500)
                            }}

                        >
                            <Typography
                                sx={{
                                    color: '#fff',
                                    fontSize: 20,
                                    fontWeight: 600,
                                    textAlign: 'center'
                                }}>Inicio</Typography>
                        </ButtonBase>
                    </Grid>

                    {SECCIONES.map((item, index) => (
                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'center', marginTop: 2}}>
                            <ButtonBase
                                onClick={() => {
                                    setOpen(false)
                                    setTimeout(() => {
                                        ir(item)
                                    }, 500)
                                }}

                            >
                                <Typography
                                    sx={{
                                        color: '#fff',
                                        fontSize: 20,
                                        fontWeight: 600,
                                        textAlign: 'center'
                                    }}>{item}</Typography>
                            </ButtonBase>
                        </Grid>
                    ))}


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                        <TextField
                            size={'small'}
                            label={'Buscar producto'}

                            color={'action'}
                            fullWidth={false}
                            sx={{width: 300}}
                            value={palabra}
                            onChange={e => setPalabra(e.target.value)}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') {
                                    navigate('/Resultados/' + palabra)
                                    setOpen(false)
                                }
                            }}
                            slotProps={{
                                input: {
                                    endAdornment: (
                                        <InputAdornment position="end"
                                                        onClick={() => {
                                                            navigate('/Resultados/' + palabra)
                                                            setOpen(false)
                                                        }}
                                                        sx={{cursor: 'pointer'}}
                                        >
                                            <Search sx={{fill: "#fff"}}/>
                                        </InputAdornment>
                                    ),
                                    disableUnderline: true,
                                    sx: {borderRadius: 10, backgroundColor: '#ffffff50', color: '#fff'}
                                },
                                inputLabel: {
                                    sx: {marginLeft: 0, borderRadius: 10, color: '#fff'}
                                }
                            }
                            }
                        />
                    </Grid>

                    <Grid container size={{xs: 12, ms: 12, md: 12}}
                          sx={{bottom: '2%', justifyContent: 'center', marginTop: 50}}>
                        <img src={logoBlanco} width={120} height={'auto'}/>
                    </Grid>

                    <Grid container size={{xs: 10, ms: 12, md: 12}}
                          sx={{bottom: '2%', justifyContent: 'center', marginTop: 2}}>
                        {/*REDES.map((item, index) => {
                            return (
                                <Grid container size={{xs: 3, ms: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                    <IconButton
                                        onClick={() => irUrl(item.url)}
                                    >
                                        <img src={item.imgColor} width={32} height={'auto'}/>
                                    </IconButton>
                                </Grid>
                            )
                        })*/}
                    </Grid>


                </Grid>

            </Drawer>

        </Grid>
    )

}
export default BarraCell